"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decideLinkCompAndTarget = void 0;
var react_1 = require("react");
var isExternalUrl_1 = require("./isExternalUrl");
var react_router_dom_1 = require("react-router-dom");
var decideLinkCompAndTarget = function (_a) {
    var to = _a.to, openInNewTab = _a.openInNewTab;
    var externalUrl = (0, isExternalUrl_1.isExternalUrl)(to);
    var LinkComp = externalUrl === null ? react_1.Fragment : externalUrl ? "a" : react_router_dom_1.Link;
    /* openInNewTab is explicitly defined, then listen to whatever it says else
       by default externalUrl will open in new tab, internalUrl will not.*/
    var target = openInNewTab === true
        ? "_blank"
        : openInNewTab === false
            ? "_self"
            : externalUrl
                ? "_blank"
                : "_self";
    return { LinkComp: LinkComp, target: target, externalUrl: externalUrl };
};
exports.decideLinkCompAndTarget = decideLinkCompAndTarget;
